<template>
  <div
    class="draggable-box"
    :style="positionStyle"
    @click="click"
    @touchstart.stop="touchStart"
    @touchmove.stop.prevent="touchMove"
    @touchend.stop="touchEnd"
    ref="draggableBoxRef"
  >
    <slot></slot>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'draggable-box',
    props: {
      stopPosition: {
        type: String,
        default: 'both', // 拖动后停留的位置，both左右都可以停留，right为放开手后停留在右边
      },
      // x位置初始位置
      initX: {
        type: Number,
        default: 16,
      },
      // y位置初始位置
      initY: {
        type: Number,
        default: 120,
      },
    },
    computed: {
      ...mapState(['isTurbo']),
      positionStyle() {
        return {
          right: `${this.btnSwitchPos.x}px`,
          bottom: `${this.btnSwitchPos.y}px`,
        }
      },
    },
    data() {
      return {
        switchPos: {
          hasMoved: false, // exclude click event
          x: 0, // right
          y: 0, // bottom
          startX: 0,
          startY: 0,
          endX: 0,
          endY: 0,
        },
        btnSwitchPos: {
          x: 0,
          y: 100,
        },
      }
    },
    mounted() {
      this.setSwitchPosition(this.initX, this.initY)
    },
    methods: {
      click() {
        this.$emit('click')
      },
      touchStart(e) {
        if (!process.client) {
          return
        }
        this.switchPos.startX = e.touches[0].pageX
        this.switchPos.startY = e.touches[0].pageY
        this.switchPos.hasMoved = false
      },
      touchMove(e) {
        if (!process.client) {
          return
        }
        if (e.touches.length <= 0) {
          return
        }
        const { switchPos } = this
        const offsetX = e.touches[0].pageX - switchPos.startX,
          offsetY = e.touches[0].pageY - switchPos.startY
        let x = Math.floor(switchPos.x - offsetX),
          y = Math.floor(switchPos.y - offsetY)
        ;[x, y] = this.getSwitchButtonSafeAreaXY(x, y)
        this.btnSwitchPos.x = x
        this.btnSwitchPos.y = y
        this.switchPos.endX = x
        this.switchPos.endY = y
        this.switchPos.hasMoved = true
        e.preventDefault()
      },

      touchEnd() {
        if (!process.client) {
          return
        }
        if (!this.switchPos.hasMoved) {
          return
        }
        this.switchPos.startX = 0
        this.switchPos.startY = 0
        this.switchPos.hasMoved = false
        this.setSwitchPosition(this.switchPos.endX, this.switchPos.endY, 'end')
      },
      getSwitchButtonSafeAreaXY(x, y) {
        const docWidth = Math.max(
          document.documentElement.offsetWidth,
          window.innerWidth
        )
        const docHeight = Math.max(
          document.documentElement.offsetHeight,
          window.innerHeight
        )
        const btnSwitch = this.$refs.draggableBoxRef
        const { offsetWidth = 0, offsetHeight = 0 } = btnSwitch || {}
        // check edge
        if (x + offsetWidth > docWidth) {
          x = docWidth - offsetWidth
        }
        if (y + offsetHeight > docHeight) {
          y = docHeight - offsetHeight
        }
        if (y > window.innerHeight - offsetHeight - 20) {
          y = window.innerHeight - offsetHeight - 20
        }
        if (x < 0) {
          x = 0
        }
        if (y < 20) {
          y = 20
        } // safe area for iOS Home indicator
        return [x, y]
      },
      setSwitchPosition(switchX, switchY, type) {
        ;[switchX, switchY] = this.getSwitchButtonSafeAreaXY(switchX, switchY)
        this.switchPos.x = switchX
        this.switchPos.y = switchY
        if (type === 'end') {
          // 松手后停留在右边
          if (this.stopPosition === 'right') {
            this.switchPos.endX =
              this.switchPos.x =
              this.btnSwitchPos.x =
                this.initX || 0
          } else if (this.stopPosition === 'left') {
            // 松手后停留在左边
            const btnSwitch = this.$refs.draggableBoxRef
            const { offsetWidth = 0 } = btnSwitch || {}
            this.switchPos.endX =
              this.switchPos.x =
              this.btnSwitchPos.x =
                window.innerWidth - offsetWidth
          } else {
            this.btnSwitchPos.x = switchX
            this.btnSwitchPos.y = switchY
          }
        } else {
          this.btnSwitchPos.x = switchX
          this.btnSwitchPos.y = switchY
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .draggable-box {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    position: fixed;
    z-index: 11;
    width: auto;
    height: auto;
    img {
      width: 480px !important;
      height: 165px !important;
      object-fit: contain;
    }
  }
</style>
